'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var index$1 = require('../../00.helper/FormField/index.js');
var classNames = _interopDefault(require('classnames/dedupe'));
var Input = require('../Input/Input.js');
require('./_index.scss.js');

var _excluded = ["className", "title", "placeholder", "value", "required", "requiredLabel", "optionalLabel", "name", "innerRef", "errorTitle", "disabled", "length"];
var CLASSNAME = 'varta-otp-input',
    cnWrapper = "".concat(CLASSNAME, "__wrapper"),
    cnDisabled = "".concat(CLASSNAME, "--disabled"),
    cnFocus = "".concat(CLASSNAME, "--focus"),
    cnError = "".concat(CLASSNAME, "--error"),
    cnTitle = "".concat(CLASSNAME, "__title"),
    cnTitleError = "".concat(cnTitle, "--error"),
    cnInput = "".concat(CLASSNAME, "__input");
/**
 * 
 */

var OtpInput = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(OtpInput, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(OtpInput);

  function OtpInput() {
    var _this$props$value;

    var _this;

    _rollupPluginBabelHelpers.classCallCheck(this, OtpInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "state", {
      error: false,
      focus: false,
      currVal: ((_this$props$value = _this.props.value) === null || _this$props$value === void 0 ? void 0 : _this$props$value.split('').slice(0, _this.props.length)) || []
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "innerRefs", []);

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onBlur", function (e) {
      var value = e.target.value,
          onBlur = _this.props.onBlur;
      var error = _this.state.error;
      var valid;

      if (error) {
        valid = _this.validate(e);
      }

      _this.setState({
        focus: false
      });

      onBlur(value, valid);
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onFocus", function () {
      var onFocus = _this.props.onFocus;

      _this.setState({
        focus: true
      });

      onFocus();
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onPaste", function (e) {
      var _this$props = _this.props,
          length = _this$props.length,
          onChange = _this$props.onChange;

      try {
        var data = e.clipboardData.getData('Text');

        _this.innerRefs.forEach(function (ref, i) {
          ref.value = data[i] || '';
        });

        _this.setState({
          currVal: data.split('').slice(0, length)
        }, function () {
          var currVal = _this.state.currVal;

          _this.innerRefs[Math.min(data.length + 1, _this.innerRefs.length) - 1].focus();

          onChange(currVal.join(''));
        });
      } catch (err) {
        console.log(err);
      }
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "validate", function (e) {
      var value = e.target.value,
          _this$props2 = _this.props,
          required = _this$props2.required,
          validator = _this$props2.validator;

      if (required && !value) {
        _this.setState({
          error: true
        });

        return false;
      }

      if (validator && value) {
        var error = !value.match(validator);

        _this.setState({
          error: error
        });

        return !error;
      }

      _this.setState({
        error: false
      });

      return true;
    });

    return _this;
  }

  _rollupPluginBabelHelpers.createClass(OtpInput, [{
    key: "onChange",
    value: function onChange(value, index) {
      var _this2 = this;

      var onChange = this.props.onChange;

      if (value && this.innerRefs[index + 1]) {
        this.innerRefs[index + 1].focus();
      }

      this.setState(function (state) {
        var currVal = state.currVal;
        currVal[index] = value;
        return {
          currVal: _rollupPluginBabelHelpers.toConsumableArray(currVal)
        };
      }, function () {
        var currVal = _this2.state.currVal;
        onChange(currVal.join(''));
      });
    }
  }, {
    key: "onInnerMount",
    value: function onInnerMount(el, index) {
      this.innerRefs[index] = el;
    }
  }, {
    key: "onInput",
    value: function onInput(e, index) {
      var value = e.target.value;

      if (value.length > 1) {
        var _value = _rollupPluginBabelHelpers.slicedToArray(value, 1),
            v = _value[0];

        this.innerRefs[index].value = v;
        this.onChange(v, index);
      }
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(e, index) {
      var key = e.keyCode || e.charCode;
      var value = e.target.value;

      if ((key === 8 || key === 46) && this.innerRefs[index - 1] && !value) {
        this.innerRefs[index - 1].focus();
        return;
      }
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this3 = this;

      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      var className = props.className,
          title = props.title,
          placeholder = props.placeholder,
          value = props.value,
          required = props.required,
          requiredLabel = props.requiredLabel,
          optionalLabel = props.optionalLabel,
          name = props.name,
          innerRef = props.innerRef,
          errorTitle = props.errorTitle,
          disabled = props.disabled,
          length = props.length,
          rest = _rollupPluginBabelHelpers.objectWithoutProperties(props, _excluded),
          _this$state = this.state,
          error = _this$state.error,
          focus = _this$state.focus,
          currVal = _this$state.currVal,
          classes = classNames(CLASSNAME, className, this.className, (_classNames = {}, _rollupPluginBabelHelpers.defineProperty(_classNames, cnError, error), _rollupPluginBabelHelpers.defineProperty(_classNames, cnFocus, focus), _rollupPluginBabelHelpers.defineProperty(_classNames, cnDisabled, disabled), _classNames));

      return /*#__PURE__*/React__default.createElement("div", {
        className: classes
      }, /*#__PURE__*/React__default.createElement("label", null, /*#__PURE__*/React__default.createElement("div", {
        className: cnTitle
      }, title, required ? requiredLabel : optionalLabel), /*#__PURE__*/React__default.createElement("div", {
        className: cnWrapper
      }, _rollupPluginBabelHelpers.toConsumableArray(Array(length - 0)).map(function (_, i) {
        return /*#__PURE__*/React__default.createElement(Input, _rollupPluginBabelHelpers.extends({
          className: cnInput,
          maxLength: 1,
          key: i,
          placeholder: placeholder === null || placeholder === void 0 ? void 0 : placeholder[i],
          value: value === null || value === void 0 ? void 0 : value[i],
          innerRef: function innerRef(el) {
            return _this3.onInnerMount(el, i);
          },
          disabled: disabled
        }, rest, {
          onChange: function onChange(e) {
            return _this3.onChange(e, i);
          },
          onKeyDown: function onKeyDown(e) {
            return _this3.onKeyDown(e, i);
          },
          onInput: function onInput(e) {
            return _this3.onInput(e, i);
          },
          onPaste: _this3.onPaste,
          required: required,
          errorTitle: ""
        }));
      })), /*#__PURE__*/React__default.createElement("div", {
        className: cnTitleError
      }, errorTitle), /*#__PURE__*/React__default.createElement("input", {
        value: currVal.join('') || value || '',
        name: name,
        ref: innerRef,
        type: "hidden"
      })));
    }
  }]);

  return OtpInput;
}(React__default.Component);
OtpInput.propTypes = _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, index$1.propTypes), {}, {
  /** Additional class name */
  className: PropTypes.string,

  /** True if disabled */
  disabled: PropTypes.bool,

  /** Ref of input element */
  innerRef: PropTypes.func,

  /** Length defines number of boxes */
  length: PropTypes.number.isRequired,

  /** Name of input in form */
  name: PropTypes.string,

  /** Callback function on blur */
  onBlur: PropTypes.func,

  /** Callback function on change */
  onChange: PropTypes.func,

  /** Callback function on focus */
  onFocus: PropTypes.func,

  /** Label to be displayed when optional */
  optionalLabel: PropTypes.string,

  /** Placeholder text with each char in one box */
  placeholder: PropTypes.string,

  /** Label to be displayed if required */
  requiredLabel: PropTypes.string,

  /** True if required in form */
  required: PropTypes.bool,

  /** Title of input */
  title: PropTypes.string,

  /** Type of input */
  type: PropTypes.string,

  /** RegEx to validate the input against */
  validator: PropTypes.instanceOf(RegExp),

  /** Current value */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
});
OtpInput.defaultProps = _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, index$1.defaultProps), {}, {
  length: 8,
  onBlur: function onBlur() {
    return null;
  },
  onChange: function onChange() {
    return null;
  },
  onFocus: function onFocus() {
    return null;
  },
  type: 'text'
});

module.exports = OtpInput;
